module.exports = __webpack_public_path__ + "img/i1.a5c29c57.jpg";